const removeHtmlTags = (html: string) => html?.replace?.(/<[^>]*>/gm, '') || '';

export default removeHtmlTags;
